<template>
    <div class="analysis-summary-container" id="tableDiv">
        <DataTable :value="events" :paginator="true" :rows="10" :rowHover="true"
                   :sortOrder="-1" sortField="last_modified_date"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[10,25,50]"
                   :currentPageReportTemplate="$t('AppAnalysisSummary.currentPageReportTemplate')"
                   class="p-datatable-striped"
                   :autoLayout="true" :style="{width: '100%', paddingTop: '0px', fontSize: '14px'}"
                   :scrollable="true"
                   ref="report" removableSort selectionMode="single">
            <template #empty>
                {{ $t('AppAnalysisSummary.Nenhum evento localizado') }}
            </template>

            <template #header>
                <div style="text-align: right">
                    <Button icon="pi pi-external-link" :label="$t('AppAnalysisSummary.Exportar')" @click="exportCsvReport($event)"/>
                </div>
            </template>

            <Column :headerStyle="{maxWidth: '40px !important', overflow: 'hidden'}"
                    :style="{maxWidth: '40px !important',overflow: 'hidden'}"
                    :bodyStyle="{maxWidth: '40px !important', backgroundColor: 'transparent', textAlign: 'center'}">
                <template #body="slotProps">
                    <Button icon="pi pi-angle-double-right" class="p-button-rounded p-button-success p-button-outlined p-0"
                            style="height: 25px;width: 25px; position: relative; right: 6px;" @click="openDialog(slotProps.data)"/>
                </template>
            </Column>

            <Column v-for="(col, index) of columns" :field="col.field" :key="col.field + '_' + index"
                    :headerStyle="{width: '150px !important'}"
                    :sortable="false" :bodyStyle="{width: '150px !important'}">
                <template #header>
                    <div style="width: 142px;">
                        <span>{{col.header}}</span>
                    </div>
                </template>
                <template #body="slotProps">
                    <div v-tooltip="displayTooltip(slotProps.data[col.field])" style="position: relative; right: 7px;">
                        {{hideValuesGreaterThanMaximumDisplay(slotProps.data[col.field])}}
                    </div>
                </template>
            </Column>


            <Column v-for="(col, index) of selectedStatisticsColumns" :headerStyle="{width: '150px !important'}"
                    :field="col.field" :bodyStyle="{position: 'relative', right: '10px', width: '150px !important'}"
                    :key="col.field + '_' + index" sortable>

                <template #header>
                    <div style="width: 113px;">
                        <span>{{col.header}}</span>
                        <MultiSelect :value="selectedStatisticsColumns"
                                    style="float: right;display: flex;align-items: center;justify-content: center;margin-top:4px;
                                        margin-left:3px;"
                                    :options="statisticsColumns"
                                    optionLabel="header"
                                    @input="onStatisticsToggle"
                                    id="columns-multiselect"
                                    appendTo="tableDiv"
                                    :filter="false">
                        </MultiSelect>
                    </div>

                </template>

                <template #body="slotProps">
                    <div v-if="col.displayOption === 'percentage'" style="width: 100%;">
                        <span class="p-column-title" v-if="slotProps.data[col.field] === 0"></span>
                        <ProgressBar v-else :value="slotProps.data[col.field]" :showValue="true">
                            {{displayStatistics(slotProps.data[col.field])}}%
                        </ProgressBar>
                    </div>

                    <div v-if="col.displayOption === 'timestampSeconds'">
                        {{getTimeFromSecondsMinusThreeHoursMixin(slotProps.data[col.field])}}
                    </div>
                    <div v-if="col.displayOption === 'durationSeconds'">
                        {{getTimeFromSecondsDurationFormatMixin(slotProps.data[col.field])}}
                    </div>
                    <div v-if="col.displayOption === 'durationHours'">
                        {{getTimeFromHoursDurationFormatMixin(slotProps.data[col.field])}}
                    </div>
                    <div v-if=" col.displayOption === 'number'">
                        {{displayStatistics(slotProps.data[col.field])}}
                    </div>
                </template>
            </Column>
        </DataTable>

        <app-analysis-summary-dialog :dialog_visible="dialogVisible" @closeDialog="setDisplayVisibleToFalse"
                                     :raw_events="events" :row_clicked="rowClicked"
                                     :raw_columns="columns" :selected_statistics_columns="selectedStatisticsColumns">
        </app-analysis-summary-dialog>

    </div>
</template>

<script>

import MultiSelect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tooltip from 'primevue/tooltip';
import ProgressBar from 'primevue/progressbar';
import ReportService from "../../../../services/ReportsService";

import Button from 'primevue/button';
import maskMacAddress from "../../../../mixins/StringsMaskMixin";
import isMacAddress from "../../../../mixins/StringsMixins"
import dateFormat from "../../../../mixins/DateMixin";
import AppAnalysisSummaryDialog from "./AppAnalysisSummaryDialog";
import getTimeFromHoursDurationFormatMixin from "@/mixins/DateMixin";
import getTimeFromSecondsMinusThreeHoursMixin from "@/mixins/DateMixin";
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";
import {mapGetters} from "vuex";
import idb from '../../../../api/idb';
import {CSV_FIELDS, CSV_LABELS} from "./AppCsvExportOptions";
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import {formatDay, getTypeByMode} from "../analysisFilters";

export default {
    mixins: [maskMacAddress, isMacAddress, dateFormat, getTimeFromHoursDurationFormatMixin,
        getTimeFromSecondsMinusThreeHoursMixin, getTimeFromSecondsDurationFormatMixin, exportJsonToCsv],
    beforeMount() {
        this.reportsService = new ReportService();
        this.columns = [
            {field: 'day', header: this.$t('AppAnalysisSummary.Dia')},
            {field: 'vehicle_display_id', header: this.$t('AppAnalysisSummary.Veículo')},
            {field: 'operator_id', header: this.$t('AppAnalysisSummary.Motorista')},
            {field: 'field', header: this.$t('AppAnalysisSummary.Local')},
            {field: 'type', header: this.$t('AppAnalysisSummary.Condição')},
            {field: 'reason_description', header: this.$t('AppAnalysisSummary.Motivo')},
            {field: 'shift', header: this.$t('AppAnalysisSummary.Turno')},
        ];
        this.statisticsColumns = [
            {field: 'event_start', header: this.$t('AppAnalysisSummary.Início'), headerStyle: "width: 110px", displayOption: 'timestampSeconds'},
            {field: 'event_end', header: this.$t('AppAnalysisSummary.Fim'), headerStyle: "width: 110px", displayOption: 'timestampSeconds'},
            {field: 'time', header: this.$t('AppAnalysisSummary.Tempo'), headerStyle: "width: 100px", displayOption: 'durationSeconds'},
            {field: 'distance', header: this.$t('AppAnalysisSummary.Distância (km)'), headerStyle: "width: 110px", displayOption: 'number'},
            {field: 'consumption', header: this.$t('AppAnalysisSummary.Combustível (L)'), headerStyle: "width: 130px", displayOption: 'number'},
            {field: 'area', header: this.$t('AppAnalysisSummary.Área (ha)'), headerStyle: "width: 125px", displayOption: 'number'},
            {field: 'yield', header: this.$t('AppAnalysisSummary.Rendimento (L/ha)'), headerStyle: "width: 150px", displayOption: 'number'},
            {field: 'consumption_rate', header: this.$t('AppAnalysisSummary.Consumo (L/h)'), headerStyle: "width: 130px", displayOption: 'number'},
            {field: 'productivity', header: this.$t('AppAnalysisSummary.Produtividade (ha/h)'), headerStyle: "width: 160px", displayOption: 'number'},
            {field: 'refuel', header: this.$t('AppAnalysisSummary.Abastecimento (L)'), headerStyle: "width: 140px", displayOption: 'number'},
        ];
        this.initializeSelectedStatisticsColumns();
        this.loadData();
    },

    data() {
        return {
            reportsService: null,

            isLoading: false,

            columns: [],
            events: [],

            statisticsColumns: null,
            selectedStatisticsColumns: null,

            dialogVisible: false,
            rowClicked: {},

            storedAnalysisColumns: null
        }
    },
    props: {
        filter_events_results: {
            type: Array,
            required: true
        }
    },
    methods: {
        initializeSelectedStatisticsColumns() {
            this.storedAnalysisColumns = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_SELECTED_ANALYSIS_COLUMNS));

            if (!this.storedAnalysisColumns) {
                this.selectedStatisticsColumns = this.statisticsColumns;
                return;
            }

            this.selectedStatisticsColumns = [];
            this.statisticsColumns.forEach(column => {
                if (this.storedAnalysisColumns[column.field] === true) {
                    this.selectedStatisticsColumns.push(column);
                }
            });
        },
        openDialog(value) {
            this.dialogVisible = true;
            this.rowClicked = value;
        },
        setDisplayVisibleToFalse() {
            this.dialogVisible = false;
        },
        onStatisticsToggle(value) {
            let selectedStatisticsBefore = this.selectedStatisticsColumns;
            this.selectedStatisticsColumns = this.statisticsColumns.filter(col => value.includes(col));
            if (this.selectedStatisticsColumns.length === 0) {
                this.selectedStatisticsColumns = selectedStatisticsBefore;
            }

            this.storedAnalysisColumns = {};
            this.statisticsColumns.forEach(column => {
                this.storedAnalysisColumns[column.field] = this.selectedStatisticsColumns.filter(e => e.field === column.field).length > 0;
            });

            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_SELECTED_ANALYSIS_COLUMNS, JSON.stringify(this.storedAnalysisColumns));
        },
        displayStatistics(value) {
            if (!value ||  typeof value != 'number' || isNaN(value)) {
                return 0
            }
            return value.toFixed(2);
        },
        displayTooltip(value) {
            if (!value) {
                return 'N/D'
            }
            return value
        },
        hideValuesGreaterThanMaximumDisplay(value) {
            const MAX_NUMBER_OF_CHARACTERS = 27;
            if (value && value.length > MAX_NUMBER_OF_CHARACTERS) {
                return value.substring(0, MAX_NUMBER_OF_CHARACTERS);
            }
            return value;
        },
        showStatistic(value) {
            if (!value || value < 0) {
                return 0;
            }
            return value;
        },
        initializeEvents(responses) {
            let events = [];
            responses.forEach(response => {
                response.forEach(responseItem => {
                    responseItem['day'] = formatDay(responseItem.event_start);
                    responseItem['type'] = getTypeByMode(responseItem['mode']);

                    responseItem['time'] = this.showStatistic(responseItem.time);
                    responseItem['distance'] = this.showStatistic(responseItem.distance);
                    responseItem['consumption'] = this.showStatistic(responseItem.consumption);
                    responseItem['area'] = this.showStatistic(responseItem.area / 10000);

                    responseItem['refuel'] = this.showStatistic(responseItem.refuel_liters);

                    responseItem['reason_description'] = responseItem['reason_description'] != null ? responseItem['reason_description'] : "";

                    responseItem['yield'] = 0;
                    responseItem['consumption_rate'] = 0;
                    responseItem['productivity'] = 0;

                    if (responseItem.time > 0) {
                        responseItem['consumption_rate'] = responseItem.consumption / (responseItem.time / 3600);
                        responseItem['productivity'] = responseItem.area / (responseItem.time / 3600);
                    }

                    if (responseItem.area > 0.01) {
                        responseItem['yield'] = responseItem.consumption / responseItem.area;
                    }

                    events.push(responseItem);
                });
            })
            events.sort((a, b) => a['event_start'] - b['event_start']);
            this.events = events;
        },
        exportCsvReport() {

            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.events));

            tempData.forEach((data, index) => {

                let selectedData = {};

                for (let prop in data) {
                    if (Object.prototype.hasOwnProperty.call(data, prop) && data[prop]) {
                        if (prop === 'day' || prop === 'vehicle_display_id' || prop === 'operator_id' ||
                            prop === 'field' || prop === 'type' || prop === 'reason_description' || prop === 'shift') {
                            selectedData[prop] = data[prop];
                            continue;
                        }

                        if (prop === 'event_start' || prop === 'event_end') {
                            selectedData[prop] = this.getTimeFromSecondsMinusThreeHoursMixin(data[prop]);
                            continue;
                        }

                        if (prop === 'time') {
                            // time vem em segundos; a coluna do CSV é "Tempo (h)"
                            selectedData[prop] = parseFloat((data[prop] / 3600).toFixed(4)).toString().replace(".", ",");
                            continue;
                        }

                        if (prop === 'distance' || prop === 'consumption' || prop === 'area' || prop === 'yield' ||
                            prop === 'consumption' || prop === 'productivity' || prop === 'consumption_rate') {
                            selectedData[prop] = data[prop].toString().replace(".", ",");
                        }
                    }
                }

                csvData.push(selectedData)
            });

            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, 'Análise-Iotag');
        },
        requestDataFromEvents(results) {
            this.initializeEvents(results);
        },
        async loadData() {
            let tempData = await idb.getData();
            if (tempData) {
                let temp = [];
                let tempWrapper = [];
                //como não diferencia as maquinas, joga tudo em um array para facilitar
                tempData.forEach((cardData) => {
                    if (cardData.events) {
                        cardData.events.forEach((events) => {
                            temp.push(events)
                        })
                    }
                });
                tempWrapper.push(temp);
                this.initializeEvents(tempWrapper);
            }
        },
    },
    computed: {
        ...mapGetters([
            'user'
        ]),
    },
    watch: {
        filter_events_results: function(val) {
            this.requestDataFromEvents(val);
        }
    },
    components: {
        MultiSelect,
        DataTable,
        Column,
        Button,
        Tooltip,
        ProgressBar,
        AppAnalysisSummaryDialog
    },
    directives: {
        'tooltip': Tooltip
    },
}
</script>


<style lang="scss">

@import "src/assets/styles/primevue";

.auto-center {
    margin-top: auto !important;
    margin-bottom: auto !important;
}

.analysis-summary-container {
    margin-top: 0;
    width: 0;
    min-width: 100%;
    overflow: hidden;
}

#columns-multiselect .p-multiselect-label-container {
    display: none !important;
}

#columns-multiselect .p-multiselect-panel {
    width: 200px !important;
}

.reports {
    margin-top: 10px;
}

.datatable-title {
    color: #495057;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center
}
</style>
